import React from 'react'
import dayjs from 'dayjs'
import { connect } from 'react-redux'
import { getBaseURL, isStaging } from 'supporticon/utils/client'
import { selectButtonDefaults, selectAPIParams } from '../../../../../store/site'
import { getFitnessTypes } from '../../../../../lib/fitness'

import DisconnectStrava from '../DisconnectStrava'
import ProviderOauthButton from 'supporticon/components/provider-oauth-button'

const FitnessButton = ({
  buttonStyles,
  fitnessOptions,
  isConnected,
  onChange,
  provider,
  page,
  user,
  apiParams = {}
}) => {
  const hasJWT = user.token.length > 32

  const getButtonProperties = () => {
    if (isConnected) {
      return {
        Component: DisconnectStrava,
        message: fitnessOptions.disconnectStravaMessage,
        onChange,
        page,
        user
      }
    } else {
      const fitnessTypes = getFitnessTypes(fitnessOptions.types)
        .map(type => type.toUpperCase())
        .filter(type => type !== 'MANUAL')

      const redirectUri = `${getBaseURL()}/${process.env.JG_API_KEY}/v1/fitness/auth/`
      const formatDate = date => dayjs(date).toISOString().substring(0, 19)

      const dateRange = [
        apiParams.startDate && `startTime=${formatDate(apiParams.startDate)}`,
        apiParams.endDate && `endTime=${formatDate(apiParams.endDate)}`
      ]
        .filter(Boolean)
        .join('&')

      return {
        Component: ProviderOauthButton,
        clientId: isStaging() ? process.env.STRAVA_STAGING_CLIENT_ID : process.env.STRAVA_PRODUCTION_CLIENT_ID,
        label: `Connect to Strava`,
        redirectUri: hasJWT ? redirectUri : `${redirectUri}${page.slug}/METRIC/${fitnessTypes.join(',')}?${dateRange}`,
        onSuccess: onChange,
        provider: 'strava',
        state: hasJWT ? `${page.slug}%3Bstrava` : user.token,
        token: user.token
      }
    }
  }

  const { Component, ...props } = getButtonProperties()

  return (
    <Component
      {...props}
      {...buttonStyles}
    />
  )
}

const mapState = (state) => ({
  buttonStyles: selectButtonDefaults(state),
  ...selectAPIParams(state)
})

export default connect(mapState)(FitnessButton)
